module.exports = __webpack_public_path__ + "assets/fox500_light.png";